import * as PIXI from 'pixi.js';
import { vec2 } from "@tlaukkan/tsm";
import { Not, System } from "ecsy";
import { raycast } from "../../../shared/box2dUtils";
import { Dead, HexTileable, Physics, Renderable, Transform } from "../../../shared/components";
import { pixelsToMeters, rotateAround } from "../../../shared/utils";

export class HexTileSystem extends System {
	execute(delta: number, time: number): void {

		//TODO OPT: We could just have a single mapping of component index to adjacent ones, rather than all these hundreds of raytraces.
		this.queries.tiles.added?.forEach(entity => {
			const transform = entity.getComponent(Transform);
			const tiling = entity.getComponent(HexTileable);
			const size = pixelsToMeters(tiling.size);
			const testDir = new vec2([1, 0]);
			rotateAround(testDir, PIXI.DEG_TO_RAD * 30, vec2.zero, testDir);
			for (let i = 0; i < tiling.tiledSides.length; ++i) {
				const hits = raycast(transform.position, testDir.copy().scale(size).add(transform.position));
				if (hits.length > 0 && hits[0].hasComponent(HexTileable)) {
					const otherTile = hits[0].getComponent(HexTileable);
					tiling.tiledSides[i] = 1;
					const oppositeIndex = (i + Math.floor(tiling.tiledSides.length / 2)) % tiling.tiledSides.length;
					otherTile.adjacent[oppositeIndex] = entity;
				}
				else {
					tiling.tiledSides[i] = 0;
				}
				rotateAround(testDir, PIXI.DEG_TO_RAD * 60, vec2.zero, testDir);
			}
		});

		this.queries.deadTile.added?.forEach(entity => {
			const tiling = entity.getComponent(HexTileable);
			for (let i = 0; i < tiling.adjacent.length; ++i) {
				const other = tiling.adjacent[i];
				if (!other || !other.hasComponent(HexTileable)) continue;
				const renderable = other.getComponent(Renderable);
				const adjacentTile = other.getComponent(HexTileable);
				const oppositeIndex = (i + Math.floor(tiling.adjacent.length / 2)) % tiling.adjacent.length;
				adjacentTile.tiledSides[oppositeIndex] = 0;

				if (renderable && renderable.sprite) {
					const idx = adjacentTile.computeTilingIndex();
					//const buffer = renderable.sprite.geometry.getBuffer("hexagonTilingIndex");
					if (tiling.buffer) {
						for (let i = 0; i < tiling.buffer?.length; ++i) {
							tiling.buffer[i] = idx;
						}
					}
					//buffer.update(new Float32Array([idx, idx, idx, idx]));
				}
			}
		});
	}
}

HexTileSystem.queries = {
	tiles: { components: [Renderable, HexTileable, Physics], listen: { added: true } },
	deadTile: { components: [Renderable, HexTileable, Physics, Dead], listen: { added: true } },
}